import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  fr: {
    // Navigation
    dashboard: 'Tableau de bord',
    clients: 'Clients',
    apartments: 'Appartements',
    whatsapp: 'IA WhatsApp',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    
    // Auth
    login: 'Connexion',
    register: "S'inscrire",
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom complet',
    signIn: 'Se connecter',
    signUp: 'Créer un compte',
    noAccount: 'Pas encore de compte?',
    hasAccount: 'Déjà un compte?',
    createAccount: 'Créer un compte',
    
    // Dashboard
    totalClients: 'Total Clients',
    availableApts: 'Disponibles',
    reservedApts: 'Réservés',
    soldApts: 'Vendus',
    hotLeads: 'Leads Chauds',
    whatsappLeads: 'Leads WhatsApp',
    recentClients: 'Clients Récents',
    clientsByStatus: 'Clients par Statut',
    overview: "Vue d'ensemble de votre activité",
    
    // Clients
    addClient: 'Ajouter un client',
    editClient: 'Modifier le client',
    phone: 'Téléphone',
    salary: 'Salaire',
    situation: 'Situation familiale',
    notes: 'Notes',
    status: 'Statut',
    temperature: 'Température',
    apartment: 'Appartement',
    actions: 'Actions',
    search: 'Rechercher...',
    filterByStatus: 'Filtrer par statut',
    allStatuses: 'Tous les statuts',
    noClients: 'Aucun client trouvé',
    
    // Statuses
    new: 'Nouveau',
    interested: 'Intéressé',
    visit: 'Visite',
    reserved: 'Réservé',
    sold: 'Vendu',
    hot: 'Chaud',
    warm: 'Tiède',
    cold: 'Froid',
    
    // Apartments
    addApartment: 'Ajouter un appartement',
    editApartment: "Modifier l'appartement",
    residence: 'Résidence',
    type: 'Type',
    price: 'Prix',
    floor: 'Étage',
    surface: 'Surface',
    available: 'Disponible',
    noApartments: 'Aucun appartement',
    
    // Settings
    residences: 'Résidences',
    users: 'Utilisateurs',
    notifications: 'Notifications',
    addResidence: 'Ajouter une résidence',
    editResidence: 'Modifier la résidence',
    address: 'Adresse',
    description: 'Description',
    admin: 'Administrateur',
    commercial: 'Commercial',
    emailNotifications: 'Notifications par email',
    notificationEmails: 'Emails de notification',
    
    // WhatsApp
    testAI: "Tester l'agent IA",
    aiConfig: 'Configuration IA',
    aiActive: 'Agent actif',
    conversationHistory: 'Historique des conversations',
    sendMessage: 'Envoyer',
    typeMessage: 'Tapez un message...',
    noConversations: 'Aucune conversation',
    
    // Export
    exportExcel: 'Exporter Excel',
    exportPDF: 'Exporter PDF',
    
    // Prospects
    prospects: 'Prospects',
    bigData: 'Big Data',
    addProspect: 'Ajouter un prospect',
    editProspect: 'Modifier le prospect',
    totalProspects: 'Total Prospects',
    citiesCovered: 'Villes couvertes',
    topType: 'Type le + demandé',
    avgBudget: 'Budget moyen',
    topCities: 'Top Villes',
    demandByType: 'Demande par Type',
    hotZones: 'Zones les + demandées',
    noProspects: 'Aucun prospect trouvé',
    searchProspect: 'Rechercher un prospect...',
    allCities: 'Toutes les villes',
    allTypes: 'Tous les types',
    city: 'Ville',
    neighborhood: 'Quartier',
    housingType: 'Type de logement',
    rooms: 'Pièces',
    desiredFloor: 'Étage souhaité',
    desiredLocation: 'Localisation souhaitée',
    paymentMethod: 'Mode de paiement',
    source: 'Source',
    analytics: 'Analytique',

    // Password
    changePassword: 'Changer le mot de passe',
    changePasswordDesc: 'Modifiez votre mot de passe de connexion',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    passwordChanged: 'Mot de passe modifié avec succès',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',

    // Audit Log & Trash
    auditLog: "Journal d'activité",
    trash: 'Corbeille',
    actions: 'actions',
    searchAudit: 'Rechercher dans le journal...',
    allActions: 'Toutes les actions',
    allEntities: 'Toutes les entités',
    dateTime: 'Date et heure',
    user: 'Utilisateur',
    action: 'Action',
    entity: 'Entité',
    changes: 'Modifications',
    noLogs: 'Aucune activité enregistrée',
    deletedItems: 'éléments supprimés',
    deletedBy: 'Supprimé par',
    deletedAt: 'Supprimé le',
    type: 'Type',
    restore: 'Restaurer',
    permanentDelete: 'Suppr. définitive',
    permanentDeleteConfirm: 'Supprimer DÉFINITIVEMENT',
    restored: 'Élément restauré avec succès',
    permanentDeleted: 'Élément supprimé définitivement',
    trashEmpty: 'La corbeille est vide',
    trashEmptyDesc: 'Les éléments supprimés apparaîtront ici',

    // Common
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    loading: 'Chargement...',
    online: 'En ligne',
    offline: 'Hors ligne',
    success: 'Succès',
    error: 'Erreur',
    confirm: 'Confirmer',
    none: 'Aucun',

    // Admin & RBAC
    administration: 'Administration',
    duplicates: 'Clients en double',
    userManagement: 'Gestion utilisateurs',
    pendingApprovals: 'Approbations en attente',
    approvalHistory: 'Historique approbations',
    approve: 'Approuver',
    reject: 'Rejeter',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    superAdmin: 'Super Administrateur',
    adminLimited: 'Administrateur Limité',
    userRole: 'Utilisateur',
    role: 'Rôle',
    active: 'Actif',
    inactive: 'Inactif',
    addUser: 'Ajouter un utilisateur',
    editUser: "Modifier l'utilisateur",
    deactivateUser: 'Désactiver',
    reference: 'Réf.',
    mergeClients: 'Fusionner',
    keepThis: 'Garder celui-ci',
    mergeInto: 'Fusionner dans',
    duplicateGroups: 'groupes de doublons',
    noApprovals: 'Aucune demande en attente',
    noDuplicates: 'Aucun doublon détecté',
    approvalRequired: "Demande d'approbation envoyée",
    requestedBy: 'Demandé par',
  },
  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    clients: 'العملاء',
    apartments: 'الشقق',
    whatsapp: 'واتساب الذكي',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    
    // Auth
    login: 'تسجيل الدخول',
    register: 'التسجيل',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم الكامل',
    signIn: 'دخول',
    signUp: 'إنشاء حساب',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب؟',
    createAccount: 'إنشاء حساب',
    
    // Dashboard
    totalClients: 'إجمالي العملاء',
    availableApts: 'متوفرة',
    reservedApts: 'محجوزة',
    soldApts: 'مباعة',
    hotLeads: 'عملاء ساخنون',
    whatsappLeads: 'عملاء واتساب',
    recentClients: 'العملاء الأخيرون',
    clientsByStatus: 'العملاء حسب الحالة',
    overview: 'نظرة عامة على نشاطك',
    
    // Clients
    addClient: 'إضافة عميل',
    editClient: 'تعديل العميل',
    phone: 'الهاتف',
    salary: 'الراتب',
    situation: 'الحالة العائلية',
    notes: 'ملاحظات',
    status: 'الحالة',
    temperature: 'درجة الاهتمام',
    apartment: 'الشقة',
    actions: 'إجراءات',
    search: 'بحث...',
    filterByStatus: 'تصفية حسب الحالة',
    allStatuses: 'جميع الحالات',
    noClients: 'لا يوجد عملاء',
    
    // Statuses
    new: 'جديد',
    interested: 'مهتم',
    visit: 'زيارة',
    reserved: 'محجوز',
    sold: 'مباع',
    hot: 'ساخن',
    warm: 'دافئ',
    cold: 'بارد',
    
    // Apartments
    addApartment: 'إضافة شقة',
    editApartment: 'تعديل الشقة',
    residence: 'المجمع السكني',
    type: 'النوع',
    price: 'السعر',
    floor: 'الطابق',
    surface: 'المساحة',
    available: 'متوفر',
    noApartments: 'لا توجد شقق',
    
    // Settings
    residences: 'المجمعات السكنية',
    users: 'المستخدمون',
    notifications: 'الإشعارات',
    addResidence: 'إضافة مجمع',
    editResidence: 'تعديل المجمع',
    address: 'العنوان',
    description: 'الوصف',
    admin: 'مدير',
    commercial: 'تجاري',
    emailNotifications: 'إشعارات البريد',
    notificationEmails: 'بريد الإشعارات',
    
    // WhatsApp
    testAI: 'اختبار الذكاء الاصطناعي',
    aiConfig: 'إعدادات الذكاء',
    aiActive: 'الوكيل نشط',
    conversationHistory: 'سجل المحادثات',
    sendMessage: 'إرسال',
    typeMessage: 'اكتب رسالة...',
    noConversations: 'لا توجد محادثات',
    
    // Export
    exportExcel: 'تصدير Excel',
    exportPDF: 'تصدير PDF',
    
    // Prospects
    prospects: 'العملاء المحتملون',
    bigData: 'البيانات الضخمة',
    addProspect: 'إضافة عميل محتمل',
    editProspect: 'تعديل العميل المحتمل',
    totalProspects: 'إجمالي العملاء المحتملين',
    citiesCovered: 'المدن المغطاة',
    topType: 'النوع الأكثر طلباً',
    avgBudget: 'متوسط الميزانية',
    topCities: 'أفضل المدن',
    demandByType: 'الطلب حسب النوع',
    hotZones: 'المناطق الأكثر طلباً',
    noProspects: 'لا يوجد عملاء محتملون',
    searchProspect: 'البحث عن عميل محتمل...',
    allCities: 'جميع المدن',
    allTypes: 'جميع الأنواع',
    city: 'المدينة',
    neighborhood: 'الحي',
    housingType: 'نوع السكن',
    rooms: 'الغرف',
    desiredFloor: 'الطابق المطلوب',
    desiredLocation: 'الموقع المطلوب',
    paymentMethod: 'طريقة الدفع',
    source: 'المصدر',
    analytics: 'التحليلات',

    // Password
    changePassword: 'تغيير كلمة المرور',
    changePasswordDesc: 'تغيير كلمة مرور تسجيل الدخول',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    passwordTooShort: 'يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل',

    // Audit Log & Trash
    auditLog: 'سجل النشاط',
    trash: 'سلة المحذوفات',
    actions: 'إجراءات',
    searchAudit: 'البحث في السجل...',
    allActions: 'جميع الإجراءات',
    allEntities: 'جميع الكيانات',
    dateTime: 'التاريخ والوقت',
    user: 'المستخدم',
    action: 'الإجراء',
    entity: 'الكيان',
    changes: 'التغييرات',
    noLogs: 'لا يوجد نشاط مسجل',
    deletedItems: 'عناصر محذوفة',
    deletedBy: 'حذف بواسطة',
    deletedAt: 'تاريخ الحذف',
    type: 'النوع',
    restore: 'استعادة',
    permanentDelete: 'حذف نهائي',
    permanentDeleteConfirm: 'حذف نهائي',
    restored: 'تم استعادة العنصر بنجاح',
    permanentDeleted: 'تم الحذف نهائيا',
    trashEmpty: 'سلة المحذوفات فارغة',
    trashEmptyDesc: 'ستظهر العناصر المحذوفة هنا',

    // Common (AR)
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    loading: 'جاري التحميل...',
    online: 'متصل',
    offline: 'غير متصل',
    success: 'نجاح',
    error: 'خطأ',
    confirm: 'تأكيد',
    none: 'لا شيء',

    // Admin & RBAC
    administration: 'الإدارة',
    duplicates: 'عملاء مكررون',
    userManagement: 'إدارة المستخدمين',
    pendingApprovals: 'طلبات معلقة',
    approvalHistory: 'سجل الموافقات',
    approve: 'موافقة',
    reject: 'رفض',
    pending: 'معلق',
    approved: 'موافق',
    rejected: 'مرفوض',
    superAdmin: 'المدير الأعلى',
    adminLimited: 'مدير محدود',
    userRole: 'مستخدم',
    role: 'الدور',
    active: 'نشط',
    inactive: 'غير نشط',
    addUser: 'إضافة مستخدم',
    editUser: 'تعديل المستخدم',
    deactivateUser: 'تعطيل',
    reference: 'المرجع',
    mergeClients: 'دمج',
    keepThis: 'الاحتفاظ بهذا',
    mergeInto: 'دمج في',
    duplicateGroups: 'مجموعات مكررة',
    noApprovals: 'لا توجد طلبات معلقة',
    noDuplicates: 'لا توجد مكررات',
    approvalRequired: 'تم إرسال طلب الموافقة',
    requestedBy: 'طلب بواسطة',
  },
  en: {
    // Navigation
    dashboard: 'Dashboard',
    clients: 'Clients',
    apartments: 'Apartments',
    whatsapp: 'WhatsApp AI',
    settings: 'Settings',
    logout: 'Logout',
    
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Full Name',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    createAccount: 'Create Account',
    
    // Dashboard
    totalClients: 'Total Clients',
    availableApts: 'Available',
    reservedApts: 'Reserved',
    soldApts: 'Sold',
    hotLeads: 'Hot Leads',
    whatsappLeads: 'WhatsApp Leads',
    recentClients: 'Recent Clients',
    clientsByStatus: 'Clients by Status',
    overview: 'Overview of your activity',
    
    // Clients
    addClient: 'Add Client',
    editClient: 'Edit Client',
    phone: 'Phone',
    salary: 'Salary',
    situation: 'Family Status',
    notes: 'Notes',
    status: 'Status',
    temperature: 'Temperature',
    apartment: 'Apartment',
    actions: 'Actions',
    search: 'Search...',
    filterByStatus: 'Filter by status',
    allStatuses: 'All statuses',
    noClients: 'No clients found',
    
    // Statuses
    new: 'New',
    interested: 'Interested',
    visit: 'Visit',
    reserved: 'Reserved',
    sold: 'Sold',
    hot: 'Hot',
    warm: 'Warm',
    cold: 'Cold',
    
    // Apartments
    addApartment: 'Add Apartment',
    editApartment: 'Edit Apartment',
    residence: 'Residence',
    type: 'Type',
    price: 'Price',
    floor: 'Floor',
    surface: 'Surface',
    available: 'Available',
    noApartments: 'No apartments',
    
    // Settings
    residences: 'Residences',
    users: 'Users',
    notifications: 'Notifications',
    addResidence: 'Add Residence',
    editResidence: 'Edit Residence',
    address: 'Address',
    description: 'Description',
    admin: 'Administrator',
    commercial: 'Commercial',
    emailNotifications: 'Email Notifications',
    notificationEmails: 'Notification Emails',
    
    // WhatsApp
    testAI: 'Test AI Agent',
    aiConfig: 'AI Configuration',
    aiActive: 'Agent Active',
    conversationHistory: 'Conversation History',
    sendMessage: 'Send',
    typeMessage: 'Type a message...',
    noConversations: 'No conversations',
    
    // Export
    exportExcel: 'Export Excel',
    exportPDF: 'Export PDF',
    
    // Prospects
    prospects: 'Prospects',
    bigData: 'Big Data',
    addProspect: 'Add Prospect',
    editProspect: 'Edit Prospect',
    totalProspects: 'Total Prospects',
    citiesCovered: 'Cities Covered',
    topType: 'Most Requested Type',
    avgBudget: 'Average Budget',
    topCities: 'Top Cities',
    demandByType: 'Demand by Type',
    hotZones: 'Hottest Zones',
    noProspects: 'No prospects found',
    searchProspect: 'Search a prospect...',
    allCities: 'All cities',
    allTypes: 'All types',
    city: 'City',
    neighborhood: 'Neighborhood',
    housingType: 'Housing Type',
    rooms: 'Rooms',
    desiredFloor: 'Desired Floor',
    desiredLocation: 'Desired Location',
    paymentMethod: 'Payment Method',
    source: 'Source',
    analytics: 'Analytics',

    // Password
    changePassword: 'Change Password',
    changePasswordDesc: 'Change your login password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    passwordChanged: 'Password changed successfully',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',

    // Audit Log & Trash
    auditLog: 'Activity Log',
    trash: 'Trash',
    actions: 'actions',
    searchAudit: 'Search activity log...',
    allActions: 'All actions',
    allEntities: 'All entities',
    dateTime: 'Date & Time',
    user: 'User',
    action: 'Action',
    entity: 'Entity',
    changes: 'Changes',
    noLogs: 'No activity recorded',
    deletedItems: 'deleted items',
    deletedBy: 'Deleted by',
    deletedAt: 'Deleted at',
    type: 'Type',
    restore: 'Restore',
    permanentDelete: 'Delete forever',
    permanentDeleteConfirm: 'PERMANENTLY delete',
    restored: 'Item restored successfully',
    permanentDeleted: 'Item permanently deleted',
    trashEmpty: 'Trash is empty',
    trashEmptyDesc: 'Deleted items will appear here',

    // Common (EN)
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    loading: 'Loading...',
    online: 'Online',
    offline: 'Offline',
    success: 'Success',
    error: 'Error',
    confirm: 'Confirm',
    none: 'None',

    // Admin & RBAC
    administration: 'Administration',
    duplicates: 'Duplicate Clients',
    userManagement: 'User Management',
    pendingApprovals: 'Pending Approvals',
    approvalHistory: 'Approval History',
    approve: 'Approve',
    reject: 'Reject',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    superAdmin: 'Super Admin',
    adminLimited: 'Limited Admin',
    userRole: 'User',
    role: 'Role',
    active: 'Active',
    inactive: 'Inactive',
    addUser: 'Add User',
    editUser: 'Edit User',
    deactivateUser: 'Deactivate',
    reference: 'Ref.',
    mergeClients: 'Merge',
    keepThis: 'Keep this one',
    mergeInto: 'Merge into',
    duplicateGroups: 'duplicate groups',
    noApprovals: 'No pending requests',
    noDuplicates: 'No duplicates detected',
    approvalRequired: 'Approval request sent',
    requestedBy: 'Requested by',
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['fr']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
